import { useQuery } from '@tanstack/react-query';
import { User } from '../../../types/User';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchCurrentUser = async () => {
  const response = await CustomAxios.get<User>(`current-user`);
  const { data } = response;
  return data;
};

export function useGetCurrentUser() {
  const query = useQuery({
    queryKey: [queryKeys.currentUser],
    staleTime: 1000 * 60 * 60, // ! might need to change this
    queryFn: fetchCurrentUser,
  });

  return query;
}
